import React from "react";
import { Button, Card, Header, List } from "semantic-ui-react";

import IChild from "../../../data/priest/Child";
import CardRow from "../CardRow";
import CardRowForDate from "../CardRowForDate";
import CardDropdownReligion from "../CardRowForReligion";

interface IChildCardProps {
    child: IChild;
    index: number;
    editMode: boolean;
    handleDelete: (index: number) => void;
    handleChangeOnChild: (labelName: string, value: any, index: number) => void;
}

const ChildCard: React.FC<IChildCardProps> = (props: IChildCardProps) => {
    const { child, index, editMode, handleDelete, handleChangeOnChild } = props;

    const handleOnClick = () => {
        handleDelete(index);
    };

    return (
        <Card fluid>
            <Card.Content>
                <Card.Content>
                    {editMode ? (
                        <Button color="red" floated="right" icon="trash" id="deleteButton" inverted onClick={handleOnClick} />
                    ) : (
                        <Card.Header id="header">
                            <Header as="h2">{child.name}</Header>
                        </Card.Header>
                    )}
                </Card.Content>
                <Card.Description>
                    <List>
                        {editMode && (
                            <List.Item>
                                <CardRow data={child.name} editMode={editMode} index={index} labelName="name" setValue={handleChangeOnChild} />
                            </List.Item>
                        )}
                        <List.Item>
                            <CardRow
                                data={child.birthPlace}
                                editMode={editMode}
                                index={index}
                                labelName="birthPlace"
                                setValue={handleChangeOnChild}
                            />
                        </List.Item>
                        <List.Item>
                            <CardRowForDate
                                data={child.birthDate}
                                editMode={editMode}
                                index={index}
                                labelName="birthDate"
                                setValue={handleChangeOnChild}
                            />
                        </List.Item>
                        <List.Item>
                            <CardDropdownReligion
                                data={child.religion}
                                editMode={editMode}
                                index={index}
                                labelName="religion"
                                setValue={handleChangeOnChild}
                            />
                        </List.Item>
                    </List>
                </Card.Description>
            </Card.Content>
        </Card>
    );
};

export default ChildCard;
